import React, { useState } from 'react'
import { Badge, Calendar as CalendarAntd, List } from 'antd'
import { useSelector } from 'react-redux'
import moment from 'moment'

import { ApplicationState } from 'src/store'
import { Empty, Modal } from 'src/components/Ant'
import { RequestItinerary } from 'src/types'

import { getStatusColor } from '..'
import { RangeDate } from '../..'
import { WrapEvents } from './styles'
import ItineraryItem from '../ItineraryItem'

interface Props {
  rangeDate: RangeDate
}

function Calendar({ rangeDate }: Props) {
  const { myTeam } = useSelector((state: ApplicationState) => ({
    myTeam: state.myTeam
  }))

  const [modalVisible, setModalVisible] = useState<boolean>(false)
  const [modalEvents, setModalEvents] = useState<RequestItinerary[]>([])

  function filterEvents(date: moment.Moment) {
    return myTeam.list.filter(item => {
      return (
        date
          .hours(0)
          .minutes(0)
          .seconds(0)
          .millisecond(0)
          .isSameOrAfter(
            moment
              .unix(item.started_on)
              .hours(0)
              .minutes(0)
              .seconds(0)
              .millisecond(0)
          ) &&
        date
          .hours(0)
          .minutes(0)
          .seconds(0)
          .millisecond(0)
          .isSameOrBefore(
            moment
              .unix(item.ended_on)
              .hours(0)
              .minutes(0)
              .seconds(0)
              .millisecond(0)
          )
      )
    })
  }

  function dateCellRender(date: moment.Moment) {
    const events = filterEvents(date)

    return (
      <WrapEvents>
        {events.map(item => (
          <li key={item.request_itinerary_id}>
            <Badge color={getStatusColor(item.status)} text={item.activity} />
          </li>
        ))}
      </WrapEvents>
    )
  }

  return (
    <>
      <CalendarAntd
        dateCellRender={dateCellRender}
        headerRender={() => <div />}
        onPanelChange={() => {}}
        onSelect={(date: moment.Moment) => {
          setModalVisible(true)
          setModalEvents(filterEvents(date))
        }}
        value={rangeDate[0]}
      />
      <Modal
        footer={null}
        onCancel={() => setModalVisible(false)}
        onOk={() => setModalVisible(false)}
        title="web.my-team.modal-title"
        visible={modalVisible}
      >
        <List
          dataSource={modalEvents}
          itemLayout="horizontal"
          locale={{ emptyText: <Empty onlyText /> }}
          renderItem={(item: RequestItinerary) => <ItineraryItem item={item} />}
        />
      </Modal>
    </>
  )
}

export default Calendar
